export const fixUrlStr = (url) => url.replace(/([^:]\/)\/+/g, '$1'); // remove double slash

export const numberWithSpaces = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const show404 = ({ from, router }) => {
  router.replace({ name: '404', params: { 0: `${from.fullPath}`, ...from.params } }).catch((error) => {
    console.info(error.message);
  });
};
